module.exports = __webpack_public_path__ + "6bbada6bec275376d08da3d0640569cd.MP3";